module.exports = __webpack_public_path__ + "media/components/Influencers/Layouts/Navigation/rewardIcon-e00dbda3c126d3d4ee4c99f556f31bed.svg";